exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "select-control {\n  border: 1px solid #ccc;\n  display: block;\n  border-radius: 5px;\n  height: 300px; }\n\n.btn {\n  display: block;\n  margin: 5px auto; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/dualSelectMenu/dualSelectMenu.component.scss
// module id = ../../../../../app/shared/components/dualSelectMenu/dualSelectMenu.component.scss
// module chunks = main